import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SystemModel } from '../_models/system.model';
import { FacilityService } from './facility.service';
import { ApiResponse } from '../_models/tag.model';

import { environment } from '../../../../environments/environment';
// import { userInfo } from 'os';
import { UUID } from 'angular2-uuid';
import { UserService } from '../../auth/_services/user.service';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

const API_SYSTEM_URL = '/api/system';
const API_ALERT_URL = '/api/alert'
const API_URL = environment.API_URL;
const RETRAINING_STATUS = '/api/system/retraining-status';
const BULK_SYSTEM_URL = '/api/system/bulk';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  systemList = [];
  systemListByFacilityChanged = new EventEmitter();
  systemList_BYUNIT = []; // added to differentiate between existsing listing as extra api is changing data
  retrainingButtonNameChanged = new EventEmitter<any>();
  systemListChanged = new EventEmitter<any[]>();
  systemFilteredListChanged = new EventEmitter<any[]>();
  systemListByUnitChanged = new EventEmitter<any[]>();
  private systemCache = new Map<string, Observable<ApiResponse<SystemModel[]>>>();

  constructor(
    private readonly http: HttpClient,
    private readonly facilityService: FacilityService,
    private readonly userService: UserService
  ) {
    // this.facilityService.facilityListChanged.subscribe(f => {
    //   console.log('Called')
    //   this.getSystem()
    // })
  }

  emptySystem() {
    this.systemList = [];
    this.systemListByUnitChanged.emit([]);
  }
  getSystemByFilter(filter, observable = false, fields = '') {
    let url = API_URL + API_SYSTEM_URL;
    let params = { ...filter, fields };
    if (observable) return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() })
    this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.systemFilteredListChanged.emit(data.data);
    });
  }

  getSystemsByIds(systemIds: string[], fields: string = '') {
    let params = new HttpParams();

    if (fields) {
      params = params.set('fields', fields);
    }
    return this.http.post(
      API_URL + BULK_SYSTEM_URL,
      { ids: systemIds },
      { params, headers: this.userService.getHttpAuthHeader() }
    );
  }

  getSystem(f = 0, filter = {}, observable = false, fields = '') {

    let url = API_URL + API_SYSTEM_URL;
    let params = filter;
    if (f) {
      /* Get system to which user has access */
      let user = JSON.parse(localStorage.getItem('user'));
      if (!user?.admin) {
        user.facility.forEach((u, index) => {
          if (index == 0)
            url += '?facility=' + u;
          else
            url += ',' + u;
        })
      }
    }
    if (fields) {
      params = {...params, fields};
    }
    if (observable) {
      return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() });
    } else {
      this.http.get(url, { params: { fields }, headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
        this.systemList = data.data;
        this.systemListChanged.emit(data.data);
      });
    }

    // let facilityList = this.facilityService.facilityList;
    // let f: any[] = [];

    // if (facilityList && facilityList.length) {
    //   let user = JSON.parse(localStorage.getItem('user'));

    //   //f = facilityList.filter(function(f){ return f.type == localStorage.getItem('type')});

    //   f = facilityList.filter(f => {
    //     return user.facility.some(uf => uf === f._id); // take the ! out and you're done
    //   });
    // } else
    //   this.facilityService.getFacility();

    // let url = API_URL + API_SYSTEM_URL;

    // f.forEach((facility, index) => {
    //   if (index == 0)
    //     url += '?facility=' + facility._id;
    //   else
    //     url += ',' + facility._id;
    // })

    // if (facilityList && facilityList.length) {
    //   this.http.get(url, {headers: this.userService.getHttpAuthHeader()}).subscribe((data: any) => {
    //     this.systemList = data.data;
    //     this.systemListChanged.emit(data.data);
    //   });
    // }
  }

  getSystemByUnit(id, observableFlag = false, fields: string = '') {
    let url = API_URL + API_SYSTEM_URL;
    let params = new HttpParams()
      .set('unit', id)
    params = params.set('fields', fields);

    if (observableFlag)
      return this.http.get(url, { headers: this.userService.getHttpAuthHeader(), params });
    this.http.get(url, { headers: this.userService.getHttpAuthHeader(), params }).subscribe((data: any) => {
      // this.systemList = data.data;
      this.systemList_BYUNIT = data.data;
      this.systemListByUnitChanged.emit(data.data);
      // this.systemListChanged.emit(data.data);
    });
  }
  getSystemByUnit_obs(id, fields = '') {
    let url = API_URL + API_SYSTEM_URL + '?unit=' + id
    if (fields) {
      url += '&fields=' + fields
    }
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader() });
  }

  getSystemByFacility(id: string, enableCache = false, fields: string = '') {
    let url = `${API_URL}${API_SYSTEM_URL}?facility=${id}`;
    let httpParams = new HttpParams();
    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }
    const headers = this.userService.getHttpAuthHeader();
    if (enableCache) {
      if (this.systemCache.has(id)) {
        return this.systemCache.get(id);
      }
      const req$ = this.http.get<ApiResponse<SystemModel[]>>(url, { params: httpParams, headers }).pipe(
        catchError(err => {
          this.systemCache.delete(id);
          return throwError(() => err);
        }),
        shareReplay(1)
      );
      this.systemCache.set(id, req$);
      return req$;
    }
    else return this.http.get<ApiResponse<SystemModel[]>>(url, { params: httpParams, headers });
  }

  clearSystemCache() {
    this.systemCache.clear();
  }

  _addLinkField(s) {
    let isArray = Array.isArray(s)
    if (isArray) {
      s.forEach(el => {
        if (!el.link) {
          el['link'] = UUID.UUID();
        }
      });
    } else {
      if (!s.link) {
        s['link'] = UUID.UUID();
      }
    }
  }

  calculateThreshold(s: SystemModel, t_window) {
    let url = API_URL + API_SYSTEM_URL + '/threshold' + '?system=' + s._id + '&table=' + s.tsTable + '&from=' + t_window.from + '&to=' + t_window.to

    return this.http.get<SystemModel>(url, { headers: this.userService.getHttpAuthHeader() })
  }

  extractSystemDataFrom(s) {
    return {
      _id: s._id,
      name: s.name.trim(),
      type: s.type,
      facility: s.facility,
      tsTable: s.tsTable,
      csvFileLocation: s.csvFileLocation,
      image: s.image,
      bucket: s.bucket,
      enabled: s.enabled,
      feature: s.feature,
      enableTrialRun: s.enableTrialRun,
      revenueRate: s.revenueRate,
      deviceId: s.deviceId,
      scadaDeviceId: s.scadaDeviceId,
      longitude: s.longitude,
      latitude: s.latitude,
      cluster: s.cluster,
      dashboard: s.dashboard,
      emailNotificationUsers: s.emailNotificationUsers,
      emailNotificationThresholdAlertsUsers: s.emailNotificationThresholdAlertsUsers,
      emailNotificationTrialRunUsers: s.emailNotificationTrialRunUsers,
      emailNotification: s.emailNotification,
      emailNotificationThresholdAlerts: s.emailNotificationThresholdAlerts,
      emailNotificationTrialRun: s.emailNotificationTrialRun,
      emailShutdownStartupNotification: s.emailShutdownStartupNotification,
      emailShutdownStartupNotificationUsers: s.emailShutdownStartupNotificationUsers,
      enableTagMongoIdFormat: s.enableTagMongoIdFormat,
      alertOwner: s.alertOwner,
      asset: [],
      blockSize: s.blockSize,
      threshold: s.threshold ? s.threshold : '[]',
      unit: s.unit ? s.unit : null,
      criticality: s.criticality,
      description: s.description,
      system_context: s.system_context,
      comment: s.comment,
      health: s.health || [],
      dataFetchSetting: s.dataFetchSetting,
      predictionSetting: s.predictionSetting,
      link: s.link ? s.link : "",
      dqSettings: s.dqSettings,
      thresholdAlertSettings: s.thresholdAlertSettings,
      manufacturer: s.manufacturer ? s.manufacturer : undefined,
      enableDiagnosticRules: s.enableDiagnosticRules,
      enableThresholdAlert: s.enableThresholdAlert,
      enableDigitalAlert: s.enableDigitalAlert,
      enableHook: s.enableHook,
      batchProcess: s.batchProcess,
      ruleBased: s.ruleBased,
      dataUrl: s.dataUrl,
      hooks: s.hooks,
      diagnosticRules: s.diagnosticRules,
      transition: s.transition,
      pauseDiagnosticRules: s.pauseDiagnosticRules,
      customInputs: s.customInputs ? s.customInputs.map(ci => {
        /* Normalize tag: form multi-select returns string[] → API expects `tags` (plural) for > 1 id,
         * `tag` (singular string) for exactly 1, and existing API rows already store tag as a string. */
        const rawTag = ci.tags ?? ci.tag;
        const tagArray = Array.isArray(rawTag) ? rawTag : (rawTag ? [rawTag] : []);
        const tagField = tagArray.length > 1
          ? { tags: tagArray }
          : { tag: tagArray[0] ?? undefined };

        /* owner can be a plain ObjectId string (from API) or { _id, name } (freshly built by component). */
        const owner = typeof ci.owner === 'string' ? ci.owner : ci.owner?._id;

        return {
          _id: ci._id,
          ...tagField,
          timeStamp: ci.timeStamp,
          note: ci.note,
          owner,
          fileUrl: ci.fileUrl
        }
      }) : [],
      escalationDelayThreshold: s.escalationDelayThreshold,
      escalationEmails: s.escalationEmails,
      escalationConfigType: s.escalationConfigType,
      alertParameter: s.alertParameter,
      smoothingSetting: s.smoothingSetting,
      connected_systems: s.connected_systems,
    }
  }

  createSystem(s: Partial<SystemModel>) {
    let system = this.extractSystemDataFrom(s);
    this._addLinkField(system);

    return this.http.post<SystemModel>(API_URL + API_SYSTEM_URL, system, { headers: this.userService.getHttpAuthHeader() })
  }

  createBulkSystem(s_list: SystemModel[]) {
    this._addLinkField(s_list);
    return this.http.post<SystemModel>(API_URL + API_SYSTEM_URL, s_list, { headers: this.userService.getHttpAuthHeader() })
  }

  updateSystem(s: Partial<SystemModel>) {
    let system = this.extractSystemDataFrom(s);
    this._addLinkField(system);

    return this.http.put<SystemModel>(API_URL + API_SYSTEM_URL, system, { headers: this.userService.getHttpAuthHeader() })
  }

  /* deleteSystem(s: SystemModel) {
    return this.http.delete<SystemModel>(API_URL + API_SYSTEM_URL + '?_id=' + s._id, { headers: httpHthis.userService.getHttpAuthHeader()eaders })
  } */

  deleteSystem(s: any) {
    return this.http.delete<SystemModel>(API_URL + API_SYSTEM_URL + '?_id=' + s, { headers: this.userService.getHttpAuthHeader() })
  }

  getdiagnosticFormulas(params = {}) {
    let url = API_URL + '/api/rule'
    return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() })
  }

  getPowerCurveData(params = {}) {
    let url = API_URL + API_SYSTEM_URL + '/calculatedPowerCurve'
    return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() })
  }

  getUserSelectionPowerCurve(params = {}) {
    let url = API_URL + API_SYSTEM_URL + '/selectedPowerCurve'
    return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() })
  }

  getAlertDataBasedOnSystem(systemData, params) {
    let url = API_URL + API_ALERT_URL + '/aggregate'
    return this.http.post(url, systemData, { params: params, headers: this.userService.getHttpAuthHeader() })
  }

  getGeneratedSystemDiagnostics(params) {
    let url = API_URL + '/api/systeminspection'
    return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() })
  }

  createSystemDiagnostics(params: any) {
    const url = API_URL + '/api/systeminspection';
    return this.http.post(url, params, { headers: this.userService.getHttpAuthHeader() });
  }

  updateSystemInspection(updateData: any) {
    const url = API_URL + '/api/systeminspection';
    return this.http.put(url, updateData, { headers: this.userService.getHttpAuthHeader() });
  }

  getRetrainingStatus(systemId: string) {
    const url = API_URL + RETRAINING_STATUS ;
    return this.http.get(url, {
      headers: this.userService.getHttpAuthHeader(),
      params: { systemId }
    });
  }

  checkAndSetRetrainingStatus(action: string, systemId: string, mbId?: string) {
    const url = API_URL + RETRAINING_STATUS ;
    return this.http.post(url,
      { action, systemId, mbId },
      { headers: this.userService.getHttpAuthHeader() }
    );
  }

  getSystemTypeOptions() {
    return [{ iconAddress: "./assets/media/dashboard/compressor.svg", label: "Compressor", value: 2 },
    { iconAddress: "./assets/media/dashboard/pump.svg", label: "Pump", "value": 3 },
    { iconAddress: "./assets/media/dashboard/valve.svg", label: "Valve", "value": 4 },
    { iconAddress: "./assets/media/dashboard/heatExchanger.svg", label: "Heat Exchanger", "value": 5 },
    { iconAddress: "./assets/media/dashboard/turbine.svg", label: "Turbine", "value": 6 },
    { iconAddress: "./assets/media/dashboard/mill.svg", label: "Mill", value: 7 },
    { iconAddress: "./assets/media/dashboard/fan.svg", label: "Fan", value: 8 },
    { iconAddress: "./assets/media/dashboard/seperator.svg", label: "Seperator", value: 9 },
    { iconAddress: "./assets/media/dashboard/cooler.svg", label: "Cooler", value: 10 },
    { iconAddress: "./assets/media/dashboard/kiln.svg", label: "Kiln", value: 11 },
    { iconAddress: "./assets/media/dashboard/preheater.svg", label: "Preheater", value: 12 },
    { iconAddress: "./assets/media/dashboard/screwCompressor.svg", label: "Screw Compressor", value: 13 },
    { iconAddress: "./assets/media/dashboard/reciprocatingCompressor.svg", label: "Reciprocating Compressor", value: 14 },
    { iconAddress: "./assets/media/dashboard/blower.svg", label: "Blower", value: 15 },
    { iconAddress: "./assets/media/dashboard/powerGenerator.svg", label: "Power Generation", value: 16 },
    { iconAddress: "./assets/media/dashboard/steamGenerator.svg", label: "Steam Generation", value: 17 },
    { iconAddress: "./assets/media/dashboard/oilWell.svg", label: "Oil Well", value: 18 },
    { iconAddress: "./assets/media/dashboard/pressureVessel.svg", label: "Pressure Vessel", value: 19 },
    { iconAddress: "./assets/media/dashboard/electricProcessHeater.svg", label: "Electric Process Heater", value: 20 },
    { iconAddress: "./assets/media/dashboard/cooledHeatExchanger.svg", label: "Fan Cooled HX", value: 21 },
    { iconAddress: "./assets/media/dashboard/firedHeater.svg", label: "Fired Heater", value: 22 },
    { iconAddress: "./assets/media/dashboard/furnace.svg", label: "Furnace", value: 23 },
    { iconAddress: "./assets/media/dashboard/windTurbine.svg", label: "Wind Turbine", value: 24 },
    { iconAddress: "./assets/media/dashboard/solar.svg", label: "Solar", value: 25 }
    ]
  }
}
